// extracted by mini-css-extract-plugin
export default {"container":"dropdown-option_container__LF0I6","label":"dropdown-option_label__7YSuy","center":"dropdown-option_center__A6O6z","count":"dropdown-option_count__5R1CX"};